require('./mortgageRequestPanelView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { isEmpty } = require('lodash');
const { connect } = require('react-redux');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestManagerDocumentation } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerDocumentation/mortgageRequestManagerDocumentation');
const { MortgageRequestDigitalGuide } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestDigitalGuide/mortgageRequestDigitalGuide');
const MortgageRequestHeader = require('components/mortgageRequest/mortgageRequestHeader/mortgageRequestHeader');
const {
    MortgageRequestTargetDateBar
} = require('components/mortgageRequest/mortgageRequestTarget/mortgageRequestTargetDateBar/mortgageRequestTargetDateBar');
const {
    MortgageRequestManagerPanel
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerPanel/mortgageRequestManagerPanel');
const {
    MortgageRequestManagerPanelSteps
} = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerPanelSteps/mortgageRequestManagerPanelSteps');
const { recordPath, PAGE_GENERIC } = require("utilities/tagging");

let lastPosition = '';

class MortgageRequestPanelView extends React.Component {
    componentDidMount() {
        const { immMortgageRequest, immMortgageRequestState } = this.props;
        const idPreaprob = !!immMortgageRequest && immMortgageRequest.get('idPreaprob');
        const idExpediente = !!immMortgageRequestState && immMortgageRequestState.get('idExpediente');
        const taggingVal = idPreaprob !== '' || !!idPreaprob ? idPreaprob : idExpediente;
        window.addEventListener('scroll', this.handleScroll);
        recordPath('hipotecario/panel', PAGE_GENERIC, '', '', null, taggingVal);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {

        if (window.innerWidth + 17 >= 768 && window.innerHeight > 650) {
            const panelLeft = $("#mortgage-panel-left");
            const panelRight = $("#mortgage-panel-right");
            const panelLeftHeight = panelLeft.height();
            const panelRightHeight = panelRight.height();

            const styles = {};
            let currentPosition = '';

            if (panelLeftHeight < panelRightHeight) {
                currentPosition = 'relative';

                if (lastPosition != currentPosition) {
                    styles.position = 'relative';
                    styles.top = '';
                    styles.left = '';
                }

            } else {
                const scroll = window.pageYOffset;
                const topbarHeight = $(".openbank-topbar").height() + $(".private-menu").height();

                if (scroll > panelLeft.offset().top - topbarHeight) {
                    const leftPositionPanelRight = panelLeft.outerWidth();

                    if (scroll + panelRightHeight + topbarHeight >= panelLeft.offset().top + panelLeftHeight) {
                        currentPosition = 'absolute';
                        if (lastPosition != currentPosition) {
                            styles.position = 'absolute';
                            styles.top = `${panelLeftHeight - panelRightHeight}px`;
                            styles.left = `${leftPositionPanelRight}px`;
                        }
                    } else {
                        currentPosition = 'fixed';

                        if (lastPosition != currentPosition) {
                            styles.position = 'fixed';
                            styles.top = `${topbarHeight}px`;
                            styles.left = `${leftPositionPanelRight + $("#mortgage-panel-body").offset().left}px`;
                            styles.width = `${panelRight.outerWidth()}px`;
                        }
                    }
                } else {
                    currentPosition = 'relative';
                    if (lastPosition != currentPosition) {
                        styles.position = 'relative';
                        styles.top = '';
                        styles.left = '';
                    }
                }
            }

            isEmpty(styles) || $(panelRight).css(styles);
            lastPosition = currentPosition;
        }
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        return (
            <div className="mortgage-request-panel-view">
                {
                    <>
                        <OKCover size="medium" section="loansmortgages">
                            <MortgageRequestHeader
                                breadcrumbConfig={mappingBreadcrumb}
                                titleKey="mortgageRequestPanel-panelTitle"
                                subtitleLeft="&nbsp;"
                                isPanel={true}
                            >
                                <MortgageRequestTargetDateBar />
                            </MortgageRequestHeader>
                        </OKCover>
                        <div id="mortgage-panel-body" className="mortgage-request-panel-view__body panelBody">
                            <div className="row no-outside-gutter">
                                <div id="mortgage-panel-left" className="mortgage-request-panel-view__left-column col-xs-8">
                                    <MortgageRequestManagerPanelSteps isClientWithoutAccounts={isClientWithoutAccounts} />
                                </div>
                                <div id="mortgage-panel-right" className="mortgage-request-panel-view__right-column col-xs-4 managerPanelInformation">
                                    <MortgageRequestManagerDocumentation />
                                    <MortgageRequestDigitalGuide />
                                    <MortgageRequestManagerPanel />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }
}

MortgageRequestPanelView.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immMortgageRequestState: PropTypes.object
};

module.exports.constructor = MortgageRequestPanelView;
module.exports.MortgageRequestPanelView = connect(
    state => ({
        immMortgageRequest: state.mortgageRequestPreApproval,
        immMortgageRequestState: state.mortgageRequestState,
        immGlobalPosition: state.globalPosition,
        immDataProprietors: state.mortgageRequestDataProprietor
    }))(MortgageRequestPanelView);

